"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../utilities/index");
var index_2 = require("../styles/index");
exports.FontClassNames = index_1.buildClassMap(index_2.DefaultFontStyles);
//# sourceMappingURL=FontClassNames.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/~/@uifabric/styling/lib/classNames/FontClassNames.js
// module id = ../node_modules/office-ui-fabric-react/node_modules/@uifabric/styling/lib/classNames/FontClassNames.js
// module chunks = 1